export default class formConfig {
  // 企业资质资格（企业资质资格专业类别详情）
  static configList() {
    return [
      {
        title: "行业分类详情",
        name: "1",
        icon: "",
        formConfigList: [
          {
            label: "行业分类编码：",
            type: "input",
            value: "industryCode",
            placeholder: "请输入",
            maxlength: 3,
            rule: {
              required: true,
              message: "请填写行业分类编码",
              trigger: "blur"
            }
          },
          {
            label: "行业分类名称：",
            type: "input",
            value: "industryName",
            placeholder: "请输入",
            maxlength: 150,
            rule: {
              required: true,
              message: "请填写行业分类名称",
              trigger: "blur"
            }
          },
          {
            label: "行业门类：",
            type: "select",
            value: "industryClassCode",
            placeholder: "请输入",
            queryParams: {
              url: "/dataDictionaryEntries/DictionaryCombobox",
              zdid: "201610191711290723"
            },
            rule: {
              required: true,
              message: "请选择行业门类",
              trigger: "blur"
            }
          },
        ]
      },
    ];
  }
}
